module.exports = __webpack_public_path__ + "static/media/iconSectionVieScolaire.76c8d5da.svg";